import ProductDescription from './ProductDescription'

const WWMuffinsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '011',
  IsBroadband: true,
  Size: '',
  WholeWheatCert: false,
}

export default WWMuffinsProduct
